import { render, staticRenderFns } from "./ClientMain.vue?vue&type=template&id=70165c92&scoped=true&"
import script from "./ClientMain.vue?vue&type=script&lang=js&"
export * from "./ClientMain.vue?vue&type=script&lang=js&"
import style0 from "./ClientMain.vue?vue&type=style&index=0&id=70165c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70165c92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSnackbar,VTextField})
